import { createTheme } from '@healthinal/ui';

export const MAX_WIDTH_PX = 2800;
export const HEADER_HEIGHT_PX = 68;
export const HEADER_PADDING_PX = 16;
export const HEADER_HEIGHT_PADDING_PX = HEADER_HEIGHT_PX + HEADER_PADDING_PX;
export const PATIENT_TABLE_CELL_HEIGHT = 43;
export const PATIENT_SIDE_LIST_ITEM_HEIGHT = 24;
export const TASK_CARD_HEIGHT = 160;
export const HISTORY_ENTRY_HEIGHT = 140;

export const theme = createTheme(
  {
    primary: {
      hue: 198,
      saturation: 100,
    },
  },
  {
    fontSize: {
      xl4: '2.625rem',
      xl3: '2.25rem',
      xl2: '1.875rem',
      xl: '1.5rem',
      lg: '1.25rem',
      md: '1.125rem',
      sm: '1rem',
      xs: '0.875rem',
    },
    components: {
      JoyCard: {
        defaultProps: {
          variant: 'plain',
        },
        styleOverrides: {
          root: {
            backgroundColor: 'var(--joy-palette-background-level1)',
          },
        },
      },
      JoySelect: {
        styleOverrides: {
          root: {
            '&:hover': {
              backgroundColor: 'var(--joy-palette-background-surface)',
            },
          },
        },
      },
      JoyButton: {
        styleOverrides: {
          root: ({ ownerState }) =>
            ownerState.variant === 'outlined' && {
              ['--Button-paddingBlock']: '0.3125rem',
              paddingInline: '0.9375rem',
            },
        },
      },
    },
  },
);
